// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.datalog.DataLogDiffResponse */
/* istanbul ignore next */
@GandalfModel
export class DataLogDiffResponse extends GandalfModelBase {

	@GandalfConstantDecorator(constants.DataLogAction)
	@GandalfProperty({ designType: constants.DataLogAction })
	currentDataLogAction!: constants.DataLogAction | null;

	@GandalfProperty({ designType: String })
	currentDataLogXml!: string | null;

	@GandalfConstantDecorator(constants.DataLogAction)
	@GandalfProperty({ designType: constants.DataLogAction })
	previousDataLogAction!: constants.DataLogAction | null;

	@GandalfProperty({ designType: String })
	previousDataLogXml!: string | null;

}
